import type { Locale } from './en';

// Hindi (हिन्दी) locale. Mirrors the English key structure exactly. Any key that
// is ever missing here automatically falls back to English at runtime.
export const hi: Locale = {
  nav: {
    home: 'होम',
    about: 'हमारे बारे में',
    features: 'विशेषताएँ',
    categories: 'श्रेणियाँ',
    howItWorks: 'यह कैसे काम करता है',
    solutions: 'समाधान',
    contact: 'संपर्क',
    complaints: 'शिकायतें',
    fileComplaint: 'शिकायत दर्ज करें',
    trackComplaint: 'शिकायत ट्रैक करें',
    signIn: 'साइन इन',
    staffDashboard: 'स्टाफ़ डैशबोर्ड',
    language: 'भाषा',
    changeLanguage: 'भाषा बदलें',
    selectLanguage: 'भाषा चुनें',
    skipToContent: 'मुख्य सामग्री पर जाएँ',
  },

  hero: {
    badge: 'एआई-संचालित नागरिक निरीक्षण',
    titleLine1: 'एआई-संचालित नागरिक',
    titleHighlight: 'स्वच्छता निरीक्षण',
    titleLine3: 'प्लेटफ़ॉर्म',
    subtitle:
      'जियो-टैग किए गए नागरिक साक्ष्य कैप्चर करें, एआई से स्वच्छता का विश्लेषण करें, नगरपालिका को रिपोर्ट भेजें, सफाई कार्य सौंपें, एसएलए ट्रैक करें, और पहले/बाद के प्रमाण से समाधान सत्यापित करें।',
    ctaFile: 'शिकायत दर्ज करें',
    ctaDemo: 'नगरपालिका डेमो बुक करें',
    ctaTrack: 'पहले से दर्ज की है? अपनी शिकायत ट्रैक करें',
    trust1: 'जीपीएस और टाइमस्टैम्प प्रमाण',
    trust2: 'एआई स्वच्छता स्कोरिंग',
    trust3: 'एसएलए और ऑडिट रिपोर्ट',
    systemStatus: 'सिस्टम स्थिति',
    allActive: 'सभी सिस्टम सक्रिय',
    degraded: 'बाधित',
    liveTracking: 'लाइव ट्रैकिंग',
    fieldCapture: 'फ़ील्ड कैप्चर',
    aiScore: 'एआई स्कोर',
    liveOverview: 'लाइव अवलोकन',
    live: 'लाइव',
    unavailable: 'अनुपलब्ध',
    statsUnavailable: 'लाइव आँकड़े अस्थायी रूप से अनुपलब्ध हैं।',
    reports: 'रिपोर्ट',
    clean: 'स्वच्छता',
    wards: 'वार्ड',
    inProgress: 'प्रगति पर',
    hotspotMap: 'हॉटस्पॉट मानचित्र',
    slaAlert: 'एसएलए अलर्ट',
    poweredBy: 'स्वच्छ भारत एआई द्वारा संचालित',
    previewLabel: 'उदाहरण उत्पाद पूर्वावलोकन',
    stepSubmitted: 'दर्ज',
    stepReview: 'समीक्षा',
    stepAssigned: 'सौंपा',
    stepCleaning: 'सफाई',
    stepVerified: 'सत्यापित',
  },

  trustStrip: {
    municipalities: 'नगरपालिकाओं के लिए',
    sanitation: 'सफाई टीमों के लिए',
    citizens: 'नागरिकों के लिए',
    inspectors: 'निरीक्षकों के लिए',
  },

  problem: {
    badge: 'चुनौती',
    title: 'मैनुअल नागरिक निरीक्षण अधूरा है',
    subtitle: 'पारंपरिक तरीके अंधे बिंदु, देरी और असत्यापित दावे पैदा करते हैं।',
    items: [
      'कागज़-आधारित निरीक्षण सत्यापित करना कठिन है',
      'तस्वीरों में जीपीएस / टाइमस्टैम्प प्रमाण नहीं होता',
      'समस्याओं का समाधान देर से होता है',
      'कोई एसएलए ट्रैकिंग नहीं',
      'साक्ष्य-आधारित जवाबदेही नहीं',
      'नागरिक प्रगति ट्रैक नहीं कर सकते',
    ],
    manualTitle: 'मैनुअल कागज़ी निरीक्षण',
    manualForm: 'हस्तलिखित फ़ॉर्म',
    manualFormSub: 'कोई स्थान नहीं · कोई समय नहीं · कोई प्रमाण नहीं',
    manualBads: ['असत्यापित दावे', 'रास्ते में खो जाते हैं', 'कोई फ़ॉलो-अप नहीं'],
    aiTitle: 'एआई मोबाइल निरीक्षण',
    aiScoreLabel: 'एआई स्वच्छता स्कोर',
    aiGoods: ['जीपीएस + टाइमस्टैम्प', 'एआई स्कोर और गंभीरता', 'समाधान तक ट्रैक'],
  },

  solution: {
    badge: 'हमारा समाधान',
    title: 'प्रौद्योगिकी-संचालित नागरिक सुरक्षा',
    subtitle: 'एआई-संचालित साक्ष्य संग्रह और केंद्रीकृत निगरानी के साथ स्वच्छता निरीक्षण को आधुनिक बनाएं।',
    cards: [
      { title: 'फ़ोटो साक्ष्य', sub: 'जीपीएस और टाइमस्टैम्प सहित' },
      { title: 'एआई विश्लेषण', sub: 'स्वचालित स्कोरिंग' },
      { title: 'लाइव ट्रैकिंग', sub: 'रीयल-टाइम अपडेट' },
      { title: 'एनालिटिक्स', sub: 'रुझान अंतर्दृष्टि' },
    ],
    checklist: [
      'एआई तुरंत स्वच्छता स्कोरिंग के लिए तस्वीरों का विश्लेषण करता है',
      'हर रिपोर्ट के साथ जीपीएस-सत्यापित साक्ष्य संलग्न',
      'नगरपालिका अधिकारियों के लिए रीयल-टाइम डैशबोर्ड',
      'नागरिक शिकायतों के माध्यम से सार्वजनिक पारदर्शिता',
    ],
  },

  lifecycle: {
    badge: 'संपूर्ण कार्यप्रवाह',
    title: 'शिकायत से समाधान तक',
    subtitle: 'एक ही, पूर्णतः ट्रैक करने योग्य जीवनचक्र — पहली तस्वीर से लेकर सत्यापित, ऑडिट-तैयार समापन तक।',
    cta: 'पूरा कार्यप्रवाह देखें',
    steps: [
      { title: 'फ़ोटो कैप्चर करें', desc: 'अधिकारी या नागरिक मौके पर नागरिक समस्या की तस्वीर लेता है।' },
      { title: 'जीपीएस और टाइमस्टैम्प प्रमाण', desc: 'हर तस्वीर पर स्थान और समय अंकित होता है।' },
      { title: 'एआई स्वच्छता विश्लेषण', desc: 'एआई स्वच्छता स्कोर देता है, समस्या और गंभीरता पहचानता है।' },
      { title: 'नगरपालिका को भेजें', desc: 'रिपोर्ट सही वार्ड और विभाग तक पहुँचती है।' },
      { title: 'व्यवस्थापक समीक्षा', desc: 'अधिकारी एआई परिणाम की पुष्टि कर कार्रवाई स्वीकृत करते हैं।' },
      { title: 'सफाई कार्य सौंपें', desc: 'कार्य समय-सीमा के साथ सफाई टीम को सौंपा जाता है।' },
      { title: 'कर्मचारी बाद की फ़ोटो अपलोड करता है', desc: 'कार्य पूरा होने पर टीम प्रमाण अपलोड करती है।' },
      { title: 'पहले / बाद का सत्यापन', desc: 'एक ही स्थान की पहले और बाद की तस्वीरों की तुलना होती है।' },
      { title: 'एसएलए समापन', desc: 'समस्या अपने एसएलए के भीतर बंद होती है — या एस्केलेट होती है।' },
      { title: 'पीडीएफ / ऑडिट रिपोर्ट', desc: 'छेड़छाड़-रहित ऑडिट रिपोर्ट तैयार होती है।' },
    ],
  },

  ai: {
    badge: 'एआई-संचालित',
    title: 'स्वच्छ भारत एआई कैसे काम करता है',
    subtitle:
      'हर तस्वीर एक एआई पाइपलाइन से गुज़रती है जो स्वच्छता स्कोर देती है, समस्या पहचानती है और कार्रवाई की सिफ़ारिश करती है — ताकि निर्णय सुसंगत, तेज़ और साक्ष्य-आधारित हों।',
    capabilities: [
      { label: 'छवि गुणवत्ता जाँचता है', desc: 'धुंधली, अंधेरी या अनुपयोगी तस्वीरें अस्वीकार करता है।' },
      { label: 'नागरिक समस्या का पता लगाता है', desc: 'कचरा, नाली, मलबा आदि पहचानता है।' },
      { label: 'स्वच्छता स्कोर देता है', desc: 'A+ से F ग्रेड के साथ 0–100 स्कोर।' },
      { label: 'गंभीरता और प्राथमिकता तय करता है', desc: 'तेज़ कार्रवाई हेतु उच्च-गंभीरता समस्याओं को चिह्नित करता है।' },
      { label: 'कार्रवाई की सिफ़ारिश करता है', desc: 'संभावित विभाग और अगला कदम सुझाता है।' },
      { label: 'डुप्लिकेट / अमान्य तस्वीरें चिह्नित करता है', desc: 'दोहराव और छेड़छाड़ की गई छवियाँ पकड़ता है।' },
    ],
    trustBold: 'एआई निर्णय लेने में सहायता करता है।',
    trustText: 'अंतिम नगरपालिका कार्रवाई की समीक्षा और ओवरराइड अधिकृत अधिकारी कर सकते हैं — नियंत्रण मनुष्यों के पास रहता है।',
    resultTitle: 'एआई विश्लेषण परिणाम',
    resultSub: 'नमूना चित्रण — कचरा अतिप्रवाह',
    sampleBadge: 'नमूना',
    scoreLabel: 'स्वच्छता स्कोर',
    grade: 'ग्रेड C',
    rows: [
      { k: 'पहचानी गई समस्या', v: 'कचरा अतिप्रवाह' },
      { k: 'गंभीरता', v: 'उच्च' },
      { k: 'अनुशंसित', v: 'सफाई टीम को सौंपें' },
      { k: 'डुप्लिकेट जाँच', v: 'उत्तीर्ण' },
    ],
    analyzedBy: 'एआई-सहायता प्राप्त नागरिक विश्लेषण · अधिकृत अधिकारियों द्वारा समीक्षा योग्य',
  },

  features: {
    badge: 'प्लेटफ़ॉर्म विशेषताएँ',
    title: 'प्रभावी निगरानी के लिए सब कुछ',
    subtitle: 'नगरपालिका अधिकारियों, निरीक्षकों और नागरिकों के लिए व्यापक उपकरण',
    unavailable: 'विशेषताएँ इस समय अनुपलब्ध हैं। कृपया बाद में पुनः प्रयास करें।',
    notConfigured: 'प्लेटफ़ॉर्म विशेषताएँ अभी कॉन्फ़िगर नहीं की गई हैं। कृपया बाद में देखें।',
    viewAll: 'सभी विशेषताएँ देखें',
  },

  workflow: {
    badge: 'कार्यप्रवाह',
    title: 'सुव्यवस्थित निरीक्षण कार्यप्रवाह',
    subtitle: 'फ़ील्ड कैप्चर से समाधान तक एक पूर्णतः ट्रैक करने योग्य प्रक्रिया',
    step: 'चरण',
    fallback: [
      { title: 'कैप्चर', description: 'फ़ील्ड अधिकारी जियो-टैग की गई तस्वीर लेता है।' },
      { title: 'विश्लेषण', description: 'एआई स्वच्छता स्कोर देता है और समस्या पहचानता है।' },
      { title: 'समीक्षा', description: 'अधिकारी एआई परिणाम की समीक्षा कर स्वीकृति देते हैं।' },
      { title: 'सौंपना', description: 'एसएलए के साथ सफाई कार्य सौंपा जाता है।' },
      { title: 'सत्यापन', description: 'पहले/बाद का प्रमाण कार्य की पुष्टि करता है।' },
      { title: 'रिपोर्ट', description: 'छेड़छाड़-रहित ऑडिट रिपोर्ट तैयार होती है।' },
    ],
  },

  beforeAfter: {
    badge: 'सत्यापन',
    title: 'प्रमाण-आधारित सफाई सत्यापन',
    subtitle:
      'हर समापन एक ही स्थान की मेल खाती पहले और बाद की तस्वीरों से समर्थित होता है — केवल एक चेकबॉक्स नहीं।',
    before: 'पहले',
    after: 'बाद में',
    beforeIssue: 'कचरा अतिप्रवाह',
    afterCleared: 'साफ़ और स्वच्छ',
    improvement: 'सुधार स्कोर',
    items: [
      { title: 'पहले की फ़ोटो', desc: 'समस्या दर्ज करते समय अधिकारी या नागरिक द्वारा ली जाती है।' },
      { title: 'बाद की फ़ोटो', desc: 'कार्य पूरा होने पर सफाई कर्मचारी द्वारा अपलोड की जाती है।' },
      { title: 'समान-स्थान सत्यापन', desc: 'जीपीएस पुष्टि करता है कि बाद की फ़ोटो दर्ज स्थल से मेल खाती है।' },
      { title: 'सुधार स्कोर', desc: 'एआई दोनों तस्वीरों की तुलना कर वास्तविक सुधार मापता है।' },
      { title: 'व्यवस्थापक सत्यापन', desc: 'समस्या बंद करने से पहले अधिकारी कार्य की पुष्टि करता है।' },
      { title: 'ठीक न होने पर पुनः खोलें', desc: 'घटिया कार्य स्वतः पुनः खोला और फिर से सौंपा जाता है।' },
      { title: 'पीडीएफ प्रमाण', desc: 'रिकॉर्ड के लिए पहले/बाद की ऑडिट पीडीएफ तैयार होती है।' },
    ],
  },

  commandCenter: {
    badge: 'नगरपालिका कमांड सेंटर',
    title: 'पूरे शहर को चलाने के लिए एक डैशबोर्ड',
    subtitle: 'एक रीयल-टाइम कमांड सेंटर जो हज़ारों रिपोर्टों को स्पष्ट, प्राथमिकता-आधारित कार्रवाई में बदलता है।',
    cta: 'डैशबोर्ड डेमो देखें',
    features: [
      { title: 'रीयल-टाइम कमांड सेंटर', desc: 'हर वार्ड और रिपोर्ट का एक लाइव दृश्य।' },
      { title: 'समीक्षा हेतु लंबित रिपोर्ट', desc: 'आधिकारिक समीक्षा की प्रतीक्षा में आने वाली रिपोर्ट।' },
      { title: 'कार्रवाई अपेक्षित रिपोर्ट', desc: 'ऐसी रिपोर्ट जिन्हें तत्काल निर्णय की आवश्यकता है।' },
      { title: 'एसएलए अतिदेय अलर्ट', desc: 'समय-सीमा चूकने पर एस्केलेशन।' },
      { title: 'असफल एआई → मैनुअल समीक्षा', desc: 'कम-विश्वास वाले एआई परिणाम मनुष्यों को भेजे जाते हैं।' },
      { title: 'वार्ड प्रदर्शन', desc: 'वार्डों में स्वच्छता की तुलना करें।' },
      { title: 'श्रेणी स्वास्थ्य स्कोर', desc: 'ट्रैक करें कि कौन-सी समस्याएँ बढ़ रही हैं।' },
      { title: 'प्राथमिकता कार्य कतार', desc: 'सबसे ज़रूरी कार्य, पहले क्रमबद्ध।' },
      { title: 'मानचित्र दृश्य', desc: 'सभी लाइव समस्याओं का भू-स्थानिक दृश्य।' },
      { title: 'पीडीएफ / सीएसवी निर्यात', desc: 'माँग पर ऑडिट-तैयार रिपोर्ट निर्यात करें।' },
    ],
    mockTitle: 'कमांड सेंटर',
    pending: 'लंबित',
    action: 'कार्रवाई',
    overdue: 'अतिदेय',
    resolved: 'समाधानित',
    review: 'समीक्षा',
    wardPerformance: 'वार्ड प्रदर्शन',
    queue: ['वार्ड 12 · कचरा अतिप्रवाह', 'वार्ड 5 · जाम नाली', 'वार्ड 9 · गंदी सड़क'],
  },

  mapIntel: {
    badge: 'मानचित्र इंटेलिजेंस',
    title: 'नागरिक हॉटस्पॉट बड़ी समस्या बनने से पहले पहचानें',
    subtitle: 'बार-बार होने वाली समस्याओं, समूहों और अतिदेय कार्यों को लाइव मानचित्र पर पहचानें — और शिकायतें बढ़ने से पहले कार्रवाई करें।',
    cta: 'मानचित्र इंटेलिजेंस देखें',
    features: [
      'मानचित्र-आधारित रिपोर्ट मार्कर',
      'वार्ड-वार समस्या समूह',
      'बार-बार कचरा डालने के स्थान',
      'अतिदेय कार्य मार्कर',
      'उच्च-गंभीरता फ़िल्टर',
      'श्रेणी हीटमैप',
      'हॉटस्पॉट सिफ़ारिशें',
    ],
    legendHigh: 'उच्च गंभीरता',
    legendOverdue: 'अतिदेय',
    legendResolved: 'समाधानित',
  },

  stakeholder: {
    badge: 'हर हितधारक के लिए बना',
    title: 'एक प्लेटफ़ॉर्म, हर भूमिका',
    subtitle: 'व्यवस्थापकों, अधिकारियों, फ़ील्ड टीमों, कर्मचारियों और नागरिकों के लिए विशेष रूप से बनाए गए उपकरण।',
    cards: [
      { title: 'नगरपालिका व्यवस्थापक', description: 'एक कमांड सेंटर से पूरे शहर का संचालन करें।', features: ['रीयल-टाइम कमांड सेंटर', 'एसएलए और एस्केलेशन', 'रिपोर्ट और एनालिटिक्स', 'पीडीएफ / सीएसवी निर्यात'] },
      { title: 'वार्ड अधिकारी', description: 'अपने वार्ड में कार्य की समीक्षा, आवंटन और सत्यापन करें।', features: ['रिपोर्ट समीक्षा', 'सफाई कार्य सौंपें', 'पूर्णता सत्यापित करें'] },
      { title: 'फ़ील्ड अधिकारी', description: 'चलते-फिरते साक्ष्य-समर्थित निरीक्षण कैप्चर करें।', features: ['निरीक्षण कैप्चर', 'एआई विश्लेषण', 'जीपीएस प्रमाण', 'रिपोर्ट भेजें'] },
      { title: 'सफाई कर्मचारी', description: 'कार्य प्राप्त करें और पूर्ण किए गए कार्य को सिद्ध करें।', features: ['कार्य प्राप्त करें', 'बाद की फ़ोटो अपलोड करें', 'कार्य पूरा करें'] },
      { title: 'नागरिक', description: 'समस्याएँ दर्ज करें और उन्हें समाधान तक ट्रैक करें।', features: ['शिकायत दर्ज करें', 'स्थिति ट्रैक करें', 'प्रतिक्रिया दें'] },
    ],
  },

  security: {
    badge: 'सुरक्षा और शासन',
    title: 'सुरक्षित नागरिक शासन के लिए निर्मित',
    subtitle: 'नगरपालिका और सरकारी खरीदारों की अपेक्षा के अनुरूप एंटरप्राइज़-ग्रेड नियंत्रण।',
    items: [
      { title: 'भूमिका-आधारित पहुँच नियंत्रण', desc: 'हर भूमिका केवल वही देखती है जो उसे देखना चाहिए।' },
      { title: 'ऑडिट लॉग', desc: 'हर क्रिया दर्ज और ट्रैक करने योग्य है।' },
      { title: 'जीपीएस और टाइमस्टैम्प प्रमाण', desc: 'साक्ष्य पर स्थान और समय अंकित होता है।' },
      { title: 'सुरक्षित मीडिया अपलोड', desc: 'तस्वीरें सुरक्षित रूप से संग्रहीत और परोसी जाती हैं।' },
      { title: 'व्यवस्थापक समीक्षा', desc: 'अधिकारी हर कार्रवाई को स्वीकृत या अस्वीकृत करते हैं।' },
      { title: 'एआई ओवरराइड', desc: 'मनुष्य किसी भी एआई परिणाम को ओवरराइड कर सकते हैं।' },
      { title: 'पीडीएफ साक्ष्य', desc: 'माँग पर छेड़छाड़-रहित ऑडिट रिपोर्ट।' },
      { title: 'डेटा गोपनीयता', desc: 'नागरिक डेटा को ज़िम्मेदारी से संभाला जाता है।' },
      { title: 'एचटीटीपीएस सुरक्षा', desc: 'टीएलएस पर एंड-टू-एंड एन्क्रिप्टेड।' },
    ],
  },

  reporting: {
    badge: 'रिपोर्टिंग',
    title: 'जवाबदेही के लिए आधिकारिक रिपोर्ट',
    subtitle: 'ऑडिट-तैयार दस्तावेज़ जो जाँच में खरे उतरते हैं — स्वचालित रूप से तैयार।',
    items: [
      'निरीक्षण पीडीएफ',
      'वार्ड सारांश पीडीएफ',
      'नागरिक शिकायत पीडीएफ',
      'पहले/बाद की पीडीएफ',
      'मासिक सीएसवी निर्यात',
      'निर्धारित ईमेल रिपोर्ट',
    ],
    cardTitle: 'निरीक्षण रिपोर्ट',
    verified: 'सत्यापित',
    before: 'पहले',
    after: 'बाद में',
    rows: [
      { k: 'श्रेणी', v: 'कचरा अतिप्रवाह' },
      { k: 'स्थान', v: '19.0760, 72.8770' },
      { k: 'दर्ज', v: '09 जुलाई 2026, 09:41' },
      { k: 'बंद', v: '09 जुलाई 2026, 15:20' },
      { k: 'एसएलए', v: 'पूर्ण (5घं 39मि)' },
    ],
    tamperEvident: 'छेड़छाड़-रहित · ऑडिट ट्रेल संलग्न',
  },

  stats: {
    liveLabel: 'लाइव प्लेटफ़ॉर्म आँकड़े',
    labels: ['कुल रिपोर्ट', 'समाधानित', 'वार्ड कवर', 'औसत स्वच्छता'],
  },

  categories: {
    badge: 'नागरिक श्रेणियाँ',
    title: 'श्रेणी के अनुसार समस्या रिपोर्ट करें',
    subtitle: 'शिकायत दर्ज करने के लिए श्रेणी चुनें — प्रत्येक रिपोर्ट एआई-सहायता प्राप्त नागरिक विश्लेषण प्राप्त कर सकती है।',
    unavailable: 'श्रेणियाँ इस समय अनुपलब्ध हैं।',
    retry: 'पुनः प्रयास करें',
    empty: 'कोई श्रेणी उपलब्ध नहीं',
    viewAll: 'सभी श्रेणियाँ देखें',
  },

  complaint: {
    badge: 'नागरिकों के लिए',
    title: 'अपनी शिकायत दर्ज करें या ट्रैक करें',
    subtitle: 'अपने क्षेत्र में नागरिक स्वच्छता सुधारने में मदद करें — नई शिकायत दर्ज करें या मौजूदा की स्थिति जाँचें।',
    fileTitle: 'नई शिकायत दर्ज करें',
    fileDesc: 'अपने क्षेत्र की स्वच्छता समस्या की रिपोर्ट करें। आपकी पहचान गोपनीय रखी जाती है और प्रगति देखने के लिए आपको एक ट्रैकिंग नंबर मिलेगा।',
    fileSteps: ['समस्या की फ़ोटो अपलोड करें', 'श्रेणी चुनें', 'अपना जीपीएस स्थान कैप्चर करें', 'ट्रैकिंग आईडी प्राप्त करें'],
    fileCta: 'नई शिकायत दर्ज करें',
    trackTitle: 'शिकायत ट्रैक करें',
    trackDesc: 'पहले से शिकायत दर्ज की है? इसे ट्रैकिंग आईडी से या वन-टाइम पासवर्ड के साथ अपने फ़ोन नंबर से ट्रैक करें।',
    trackSteps: ['अपनी ट्रैकिंग आईडी दर्ज करें', 'ओटीपी से सत्यापित करें (फ़ोन द्वारा)', 'अपनी स्थिति टाइमलाइन देखें', 'समाधान प्रमाण देखें'],
    trackCta: 'शिकायत ट्रैक करें',
    timelineLabel: 'आपकी शिकायत की स्थिति, आरंभ से अंत तक',
    statuses: ['दर्ज', 'समीक्षाधीन', 'कार्रवाई नियोजित', 'प्रगति पर', 'समाधानित'],
  },

  faq: {
    badge: 'सामान्य प्रश्न',
    title: 'अक्सर पूछे जाने वाले प्रश्न',
    subtitle: 'नागरिकों, नगरपालिकाओं और सरकारी खरीदारों के लिए सीधे उत्तर।',
    stillQuestions: 'अभी भी प्रश्न हैं?',
    talkToTeam: 'हमारी टीम से बात करें',
    items: [
      { q: 'स्वच्छ भारत का उपयोग कौन कर सकता है?', a: 'नगरपालिकाएँ, वार्ड और फ़ील्ड अधिकारी, सफाई कर्मचारी और आम नागरिक। हर भूमिका को उद्देश्य-निर्मित अनुभव मिलता है — व्यवस्थापक कमांड सेंटर से लेकर नागरिक शिकायत फ़ॉर्म तक।' },
      { q: 'क्या यह एक सरकारी ऐप है?', a: 'स्वच्छ भारत एक निजी कंपनी द्वारा निर्मित नागरिक प्रौद्योगिकी प्लेटफ़ॉर्म है। यह नगरपालिकाओं और नागरिक प्राधिकरणों द्वारा तैनाती के लिए बनाया गया है और कोई सरकारी संबद्धता का दावा नहीं करता।' },
      { q: 'एआई विश्लेषण कैसे काम करता है?', a: 'हर तस्वीर का स्वच्छ भारत एआई द्वारा विश्लेषण किया जाता है ताकि छवि गुणवत्ता जाँची जाए, नागरिक समस्या पहचानी जाए, स्वच्छता स्कोर और गंभीरता दी जाए, और कार्रवाई की सिफ़ारिश की जाए। परिणाम अधिकृत अधिकारियों द्वारा समीक्षा योग्य हैं।' },
      { q: 'क्या एआई परिणामों की मैनुअल समीक्षा हो सकती है?', a: 'हाँ। एआई निर्णय में सहायता करता है, परंतु अधिकृत अधिकारी कार्रवाई से पहले किसी भी एआई परिणाम की समीक्षा, ओवरराइड, पुनः विश्लेषण या अस्वीकार कर सकते हैं। नियंत्रण मनुष्यों के पास रहता है।' },
      { q: 'क्या नागरिक शिकायतें ट्रैक कर सकते हैं?', a: 'हाँ। नागरिकों को एक ट्रैकिंग आईडी मिलती है और वे एक स्पष्ट स्थिति टाइमलाइन का अनुसरण कर सकते हैं — दर्ज, समीक्षाधीन, कार्रवाई नियोजित, प्रगति पर, समाधानित — और समाधान प्रमाण देख सकते हैं।' },
      { q: 'क्या यह ऑफ़लाइन काम करता है?', a: 'फ़ील्ड कैप्चर अनुभव मोबाइल-प्रथम है और कमज़ोर नेटवर्क को सहन करता है, साक्ष्य को कतारबद्ध कर कनेक्टिविटी लौटने पर सिंक करता है ताकि फ़ील्ड टीमें कभी न रुकें।' },
      { q: 'क्या नगरपालिका सफाई कार्य सौंप सकती है?', a: 'हाँ। वार्ड अधिकारी सफाई टीमों को समय-सीमा के साथ कार्य सौंप सकते हैं, और पहले/बाद के प्रमाण तथा एसएलए टाइमर के साथ पूर्णता ट्रैक कर सकते हैं।' },
      { q: 'क्या यह जीपीएस प्रमाण का समर्थन करता है?', a: 'हर तस्वीर पर जीपीएस निर्देशांक और टाइमस्टैम्प अंकित होता है, और धोखाधड़ी रोकने के लिए बाद की तस्वीरें दर्ज स्थान के विरुद्ध सत्यापित की जाती हैं।' },
      { q: 'क्या रिपोर्ट पीडीएफ के रूप में निर्यात हो सकती हैं?', a: 'हाँ। निरीक्षण रिपोर्ट, वार्ड सारांश, शिकायत रिकॉर्ड और पहले/बाद के प्रमाण छेड़छाड़-रहित पीडीएफ के रूप में निर्यात किए जा सकते हैं, साथ ही मासिक सीएसवी और निर्धारित ईमेल रिपोर्ट भी।' },
      { q: 'क्या इसे किसी शहर या नगरपालिका के लिए अनुकूलित किया जा सकता है?', a: 'हाँ। श्रेणियाँ, वार्ड, एसएलए नियम, एस्केलेशन नीतियाँ और ब्रांडिंग हर नगरपालिका के अनुसार कॉन्फ़िगर की जा सकती हैं। अपने शहर की आवश्यकताओं पर चर्चा हेतु डेमो बुक करें।' },
    ],
  },

  cta: {
    badge: 'शुरू करें',
    title: 'नागरिक स्वच्छता निगरानी को बदलने के लिए तैयार हैं?',
    subtitle: 'एआई-संचालित साक्ष्य संग्रह, एसएलए ट्रैकिंग और केंद्रीकृत निगरानी के साथ स्वच्छता निरीक्षण को आधुनिक बनाने में नगरपालिकाओं का साथ दें।',
    primary: 'नगरपालिका डेमो बुक करें',
    secondary: 'शिकायत दर्ज करें',
  },

  footer: {
    tagline: 'एआई नागरिक निरीक्षण प्लेटफ़ॉर्म',
    description:
      'नगरपालिकाओं और नागरिक प्राधिकरणों के लिए एक निजी-कंपनी नागरिक प्रौद्योगिकी प्लेटफ़ॉर्म। स्वच्छ, स्वस्थ समुदायों के लिए एआई-सहायता प्राप्त स्वच्छता निगरानी — सरकारी ऐप नहीं।',
    india: 'भारत',
    product: 'उत्पाद',
    company: 'कंपनी',
    complaints: 'शिकायतें',
    legal: 'कानूनी',
    links: {
      features: 'विशेषताएँ',
      categories: 'श्रेणियाँ',
      howItWorks: 'यह कैसे काम करता है',
      solutions: 'समाधान',
      about: 'हमारे बारे में',
      contact: 'संपर्क',
      signIn: 'साइन इन',
      fileComplaint: 'शिकायत दर्ज करें',
      trackComplaint: 'अपनी शिकायत ट्रैक करें',
      privacy: 'गोपनीयता नीति',
      terms: 'सेवा की शर्तें',
    },
    ctaTitle: 'शुरू करने के लिए तैयार हैं?',
    ctaSubtitle: 'आज ही अपनी नगरपालिका की नागरिक निरीक्षण प्रक्रिया को बदलें।',
    requestDemo: 'डेमो का अनुरोध करें',
    signIn: 'साइन इन',
    rights: 'सर्वाधिकार सुरक्षित।',
    designedFor: 'नगरपालिकाओं और नागरिक प्राधिकरणों के लिए एक निजी कंपनी द्वारा निर्मित',
  },
};
